import { useModules } from '@izimi/modules';
import { ApiDocumentSource } from 'api';

type Props = {
  withContactRequests?: boolean;
};

export const usePendingItemsCount = ({ withContactRequests = true }: Props = {}) => {
  const {
    documents: { usePagedDocuments },
    shared: { usePagedSharedItems },
    contacts: { usePagedContacts },
  } = useModules();

  const { total: totalContactRequests, isLoading: isLoadingContactRequests } = usePagedContacts({
    params: { status: ['PENDING'], pageSize: 1 },
    type: 'contactRequests',
    enabled: withContactRequests,
  });

  const { total: totalPendingSharedDocuments, isLoading: isLoadingPendingSharedDocuments } = usePagedDocuments({
    params: {
      sources: [ApiDocumentSource.Shared],
      states: 'PENDING',
      limit: 1,
    },
    type: 'sharedToYouList',
  });

  const { metadata, isLoading } = usePagedSharedItems();

  const count = 0 +
    ((withContactRequests && totalContactRequests) || 0) +
    (totalPendingSharedDocuments ?? 0) +
    (metadata?.numberPendingPushedDocuments ?? 0) +
    (metadata?.numberUnseenCommunications ?? 0) +
    (metadata?.numberUnseenExpiringCommunications ?? 0);

  return {
    count,
    isLoading: isLoading || isLoadingPendingSharedDocuments || isLoadingContactRequests,
  };
};
